import {
  Box,
  Button,
  ClickAwayListener,
  makeStyles,
  Paper,
  Popper,
  PopperPlacementType,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import React, { useRef, useState } from 'react';

import { BorderWidthWithColor } from '../../../../../../../core/config/mainTheme';
import { toCssValue } from '../../../../../../../core/utils/theme.utils';
import ConnectionsForm from '../../ConnectionsForm/ConnectionsForm';
import ConnectionsLegend from '../ConnectionsLegend/ConnectionsLegend';

export interface ActionBoxProps {
  buttonTitle?: string;
  placement?: PopperPlacementType;
}

const FormActionBox: React.FC<ActionBoxProps> = ({ buttonTitle, placement = 'bottom-end' }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  return (
    <Box className={`${classes.rightBox}`}>
      <Button
        className={classes.button}
        aria-controls="customized-menu"
        ref={anchorRef}
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        {buttonTitle}
        <ArrowDropDownIcon />
      </Button>
      <ClickAwayListener onClickAway={handleClose}>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          transition
          disablePortal
          placement={placement}
          className={classes.menuBox}
        >
          <Paper className={classes.dropContainer}>
            <ConnectionsForm />
            <ConnectionsLegend />
          </Paper>
        </Popper>
      </ClickAwayListener>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  menuBox: {
    zIndex: 2,
  },
  dropContainer: {
    background: theme.palette.primary.dark,
    color: theme.palette.background.paper,
    borderTop: BorderWidthWithColor(1, theme.palette.primary.contrastText),
    borderRadius: 0,
    padding: toCssValue([theme.spacing(8), theme.spacing(12)]),
  },
  rightBox: {
    marginLeft: 'auto',
    position: 'relative',
    display: 'flex',
    background: theme.palette.primary.dark,
    '& button': {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  },
  button: {
    background: theme.palette.primary.dark,
    borderRight: `1px solid ${theme.palette.background.paper}`,
    borderLeft: `1px solid ${theme.palette.background.paper}`,
    borderRadius: 0,
    '& svg': {
      marginLeft: '10px',
    },
  },
}));

export default FormActionBox;
